import React from "react";
import { projects } from "../mock";
import { ArrowUpRight } from "lucide-react";

const Projects = () => {
  return (
    <section id="projects" className="section-pad bg-[#0e0e0f]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <h2 className="font-serif-display text-white" style={{ fontSize: "clamp(2rem, 4vw, 3.5rem)" }}>
              Lucrări Reprezentative
            </h2>
            <p className="mt-4 text-neutral-400 text-[17px] max-w-xl">
              O selecție din proiectele care ne definesc — fiecare o poveste despre spațiu, oameni și cultură.
            </p>
          </div>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 text-[#f5b301] hover:text-[#fde68a] transition-colors text-sm tracking-[0.24em] uppercase font-medium"
          >
            Vezi toate proiectele <ArrowUpRight size={16} />
          </a>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-8">
          {projects.map((p) => (
            <article
              key={p.title}
              className="bg-[#17171a] rounded-2xl overflow-hidden hover-lift group cursor-pointer"
            >
              <div className="img-zoom h-[300px] md:h-[360px] overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-7">
                <div className="flex items-center gap-3 text-[#f5b301] text-[12px] tracking-[0.28em] font-medium">
                  <span>{p.year}</span>
                  <span className="w-1 h-1 rounded-full bg-[#f5b301]" />
                  <span>{p.city}</span>
                </div>
                <h3 className="font-serif-display text-white text-3xl md:text-[32px] mt-4">{p.title}</h3>
                <p className="mt-3 text-neutral-400 leading-relaxed text-[15px]">{p.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
